<script setup>
defineProps({
  name: { type: String, required: true },
  size: { type: Number, default: 18 },
})
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="name === 'support'">
      <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
      <path d="M18 19c0 1.1-.9 2-2 2h-3" />
      <path d="M4 14a2 2 0 0 1 2-2h1v6H6a2 2 0 0 1-2-2zM20 14a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2z" />
    </template>
    <template v-else-if="name === 'implantation'">
      <path d="m12 3 8 4.5v9L12 21l-8-4.5v-9z" />
      <path d="m4.3 7.7 7.7 4.4 7.7-4.4M12 21v-8.9" />
    </template>
    <template v-else-if="name === 'inbox'">
      <path d="M4 5h16v14H4zM4 14h4l2 3h4l2-3h4" />
    </template>
    <template v-else-if="name === 'board'">
      <rect x="3" y="4" width="5" height="16" rx="1" />
      <rect x="10" y="4" width="5" height="10" rx="1" />
      <rect x="17" y="4" width="4" height="13" rx="1" />
    </template>
    <template v-else-if="name === 'target'">
      <circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="3" /><path d="m16 8 5-5M17 3h4v4" />
    </template>
    <template v-else-if="name === 'chart'">
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </template>
    <template v-else-if="name === 'building'">
      <path d="M4 21V4h12v17M16 9h4v12M8 8h4M8 12h4M8 16h4M2 21h20" />
    </template>
    <template v-else-if="name === 'users'">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </template>
    <template v-else-if="name === 'team'">
      <circle cx="8" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" /><path d="M2 20a6 6 0 0 1 12 0M13 18a5 5 0 0 1 9 2" />
    </template>
    <template v-else-if="name === 'clock'">
      <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
    </template>
    <template v-else-if="name === 'bell'">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />
    </template>
    <template v-else-if="name === 'search'">
      <circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" />
    </template>
    <template v-else-if="name === 'filter'">
      <path d="M4 6h16M7 12h10M10 18h4" />
    </template>
    <template v-else-if="name === 'group'">
      <path d="M5 7h4M5 12h8M5 17h12" /><circle cx="17" cy="7" r="2" />
    </template>
    <template v-else-if="name === 'sort'">
      <path d="M8 6h10M8 12h7M8 18h4M4 4v16M2 18l2 2 2-2" />
    </template>
    <template v-else-if="name === 'close'">
      <path d="M6 6l12 12M18 6 6 18" />
    </template>
    <template v-else-if="name === 'circle-check'">
      <circle cx="12" cy="12" r="9" /><path d="m8 12 2.5 2.5L16 9" />
    </template>
    <template v-else-if="name === 'expand'">
      <path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5M3 8l6-6M21 8l-6-6M3 16l6 6M21 16l-6 6" />
    </template>
    <template v-else-if="name === 'shrink'">
      <path d="M9 9H4V4M15 9h5V4M9 15H4v5M15 15h5v5M4 4l6 6M20 4l-6 6M4 20l6-6M20 20l-6-6" />
    </template>
    <template v-else-if="name === 'plus'">
      <path d="M12 5v14M5 12h14" />
    </template>
    <template v-else-if="name === 'chevron'">
      <path d="m9 18 6-6-6-6" />
    </template>
    <template v-else-if="name === 'collapse'">
      <path d="m14 18-6-6 6-6M20 18l-6-6 6-6" />
    </template>
    <template v-else-if="name === 'more'">
      <circle cx="5" cy="12" r=".8" fill="currentColor" /><circle cx="12" cy="12" r=".8" fill="currentColor" /><circle cx="19" cy="12" r=".8" fill="currentColor" />
    </template>
    <template v-else-if="name === 'calendar'">
      <rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" />
    </template>
    <template v-else-if="name === 'briefcase'">
      <rect x="3" y="7" width="18" height="13" rx="2" /><path d="M9 7V4h6v3M3 12h18M10 12v2h4v-2" />
    </template>
    <template v-else-if="name === 'lock'">
      <rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
    </template>
    <template v-else-if="name === 'eye'">
      <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" /><circle cx="12" cy="12" r="2.5" />
    </template>
    <template v-else-if="name === 'eye-off'">
      <path d="m3 3 18 18M10.6 6.2A10 10 0 0 1 12 6c6 0 9.5 6 9.5 6a16 16 0 0 1-2.1 2.8M6.2 6.2C3.8 8 2.5 12 2.5 12s3.5 6 9.5 6c1 0 2-.2 2.8-.5M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    </template>
    <template v-else-if="name === 'user-x'">
      <path d="M14 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1" /><circle cx="8" cy="7" r="4" /><path d="m17 8 5 5M22 8l-5 5" />
    </template>
    <template v-else-if="name === 'pencil'">
      <path d="m17 3 4 4L8 20l-5 1 1-5zM14 6l4 4" />
    </template>
    <template v-else-if="name === 'key'">
      <circle cx="7.5" cy="15.5" r="4.5" /><path d="m11 12 10-10M15.5 7.5l3 3" />
    </template>
    <template v-else-if="name === 'refresh'">
      <path d="M21 12a9 9 0 1 1-2.6-6.4M21 3v5h-5" />
    </template>
    <template v-else-if="name === 'copy'">
      <rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </template>
    <template v-else-if="name === 'bot'">
      <path d="M12 8V4M9 4h6" /><rect x="4" y="8" width="16" height="12" rx="2" /><path d="M2 14h2M20 14h2M9 13v2M15 13v2" />
    </template>
    <template v-else-if="name === 'send'">
      <path d="M21 3 10 14M21 3l-7 18-4-7-7-4z" />
    </template>
    <template v-else-if="name === 'minus'">
      <path d="M5 12h14" />
    </template>
    <template v-else-if="name === 'download'">
      <path d="M12 4v11m0 0 4-4m-4 4-4-4" /><path d="M5 19h14" />
    </template>
    <template v-else-if="name === 'paperclip'">
      <path d="m20 10.5-8.3 8.3a5 5 0 0 1-7-7l8.7-8.7a3.3 3.3 0 0 1 4.7 4.7l-8.7 8.6a1.7 1.7 0 0 1-2.3-2.3L15 6.3" />
    </template>
    <template v-else>
      <circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" />
    </template>
  </svg>
</template>
